import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

const DashboardRencar = () => {
  const navigate = useNavigate();
  const [cargando, setCargando] = useState(true);
  const [stats, setStats] = useState({
    vehiculos_disponibles: 0,
    rentas_activas: 0,
    vehiculos_rentados: 0,
    ingresos_mes: 0,
    ingresos_proyectados: 0,
    rentas_vencidas: 0,
    total_vehiculos: 0,
    porcentaje_ocupacion: 0
  });
  const [rentasPendientesInspeccion, setRentasPendientesInspeccion] = useState([]);
  const [rentasRecientes, setRentasRecientes] = useState([]);

  // ═══════════════════════════════════════════════════════════════════
  // 📥 CARGAR DATOS
  // ═══════════════════════════════════════════════════════════════════
  const cargarDashboard = async () => {
    try {
      setCargando(true);
      
      // 1. Cargar estadísticas generales
      const resStats = await api.get("/rencar/dashboard/stats");
      setStats(resStats.data);

      // 2. Cargar rentas para filtrar pendientes de inspección
      const resRentas = await api.get("/rencar/rentas/abiertas");
      const todasLasRentas = resRentas.data.rentas || [];

      // Filtrar las que aún no tienen inspección de salida (estado 'abierta')
      const pendientes = todasLasRentas.filter(r => r.estado === 'abierta');
      setRentasPendientesInspeccion(pendientes);

      // Mostrar las 5 más recientes en la lista general
      setRentasRecientes(todasLasRentas.slice(0, 5));

    } catch (error) {
      console.error("❌ Error cargando dashboard RentaCar:", error);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarDashboard();
  }, []);

  if (cargando) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.spinner}></div>
        <p style={styles.loadingText}>Sincronizando flota...</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* HEADER */}
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>🚗 Dashboard RentaCar</h1>
          <p style={styles.subtitle}>Gestión inmersiva de flota y contratos</p>
        </div>
        <button
          style={styles.btnPrimary}
          onClick={() => navigate("/rencar/rentas/crear")}
        >
          ➕ Nueva Renta
        </button>
      </div>

      {/* ESTADÍSTICAS (Mantenemos tu diseño premium) */}
      <div style={styles.statsGrid}>
        <div style={styles.statCard}>
          <div style={styles.statIcon}>🚙</div>
          <div>
            <div style={styles.statValue}>{stats.total_vehiculos}</div>
            <div style={styles.statLabel}>Total Flota</div>
          </div>
        </div>

        <div style={{...styles.statCard, borderLeft: '4px solid #16a34a'}}>
          <div style={{...styles.statIcon, background: '#d1fae5', color: '#16a34a'}}>✅</div>
          <div>
            <div style={styles.statValue}>{stats.vehiculos_disponibles}</div>
            <div style={styles.statLabel}>Disponibles</div>
          </div>
        </div>

        <div style={{...styles.statCard, borderLeft: '4px solid #3b82f6'}}>
          <div style={{...styles.statIcon, background: '#dbeafe', color: '#3b82f6'}}>📋</div>
          <div>
            <div style={styles.statValue}>{stats.rentas_activas}</div>
            <div style={styles.statLabel}>Contratos Activos</div>
          </div>
        </div>

        <div style={{...styles.statCard, borderLeft: '4px solid #10b981'}}>
          <div style={{...styles.statIcon, background: '#d1fae5', color: '#10b981'}}>💰</div>
          <div>
            <div style={{...styles.statValue, fontSize: '24px'}}>
              USD ${stats.ingresos_mes.toLocaleString('en-US', { minimumFractionDigits: 2 })}
            </div>
            <div style={styles.statLabel}>Ingresos Mes</div>
          </div>
        </div>
      </div>

      {/* ⚡ SECCIÓN CRÍTICA: INSPECCIONES PENDIENTES */}
      {rentasPendientesInspeccion.length > 0 && (
        <div style={styles.criticalCard}>
          <div style={styles.cardHeader}>
            <h3 style={{...styles.cardTitle, color: '#92400e'}}>⚠️ Pendientes de Inspección de Salida</h3>
            <span style={styles.alertBadge}>{rentasPendientesInspeccion.length} pendiente(s)</span>
          </div>
          <div style={styles.listContainer}>
            {rentasPendientesInspeccion.map((renta) => (
              <div key={renta.id} style={styles.criticalItem}>
                <div style={styles.listItemContent}>
                  <div style={styles.listItemTitle}>
                    {renta.Vehiculo?.marca} {renta.Vehiculo?.modelo} — <span style={{color: '#3b82f6'}}>{renta.Vehiculo?.placa}</span>
                  </div>
                  <div style={styles.listItemSubtitle}>Cliente: {renta.Cliente?.nombre}</div>
                </div>
                <button
                  style={styles.btnActionSalida}
                  onClick={() => navigate(`/rencar/inspeccion-salida/${renta.id}`)}
                >
                  📝 Iniciar Inspección
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* FILA DE CONTENIDO SECUNDARIO */}
      <div style={styles.twoColumnGrid}>
        {/* RENTAS RECIENTES */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <h3 style={styles.cardTitle}>📋 Últimos Movimientos</h3>
            <button style={styles.btnLink} onClick={() => navigate("/rencar/rentas-abiertas")}>Ver todas →</button>
          </div>

          <div style={styles.listContainer}>
            {rentasRecientes.map((renta) => (
              <div key={renta.id} style={styles.listItem}>
                <div style={styles.listItemContent}>
                  <div style={styles.listItemTitle}>{renta.Vehiculo?.marca} {renta.Vehiculo?.modelo}</div>
                  <div style={styles.listItemSubtitle}>{renta.Cliente?.nombre}</div>
                </div>
                <div style={styles.listItemValue}>
                   {/* Botón dinámico según el estado */}
                   {renta.estado === 'en_uso' ? (
                     <button
                       style={styles.btnActionEntrada}
                       onClick={() => navigate(`/rencar/inspeccion-entrada/${renta.id}`)}
                     >
                       📥 Recibir
                     </button>
                   ) : renta.estado === 'en_renta' ? (
                     <span style={{...styles.textWarning, color: '#3b82f6'}}>💵 Cobrar en POS</span>
                   ) : (
                     <span style={styles.textWarning}>⏳ Sin Inspección</span>
                   )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ACCESOS RÁPIDOS */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <h3 style={styles.cardTitle}>🛠️ Panel de Control</h3>
          </div>
          <div style={styles.quickActionsVertical}>
            <button style={styles.quickActionBtn} onClick={() => navigate("/rencar/vehiculos")}>🚙 Gestión de Flota</button>
            <button style={styles.quickActionBtn} onClick={() => navigate("/rencar/rentas-abiertas")}>📋 Control de Rentas</button>
            <button style={styles.quickActionBtn} onClick={() => navigate("/rencar/reportes")}>📊 Reportes Financieros</button>
          </div>
        </div>
      </div>

      <style>{` @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } } `}</style>
    </div>
  );
};

// ═══════════════════════════════════════════════════════════════════
// 🎨 ESTILOS ACTUALIZADOS (UNIFICADOS)
// ═══════════════════════════════════════════════════════════════════
const styles = {
  container: { minHeight: "calc(100vh - 70px)", background: "linear-gradient(180deg, #f0f9ff 0%, #e0f2fe 50%, #f0f9ff 100%)", padding: "24px 32px", fontFamily: "'Segoe UI', sans-serif" },
  header: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" },
  title: { fontSize: "32px", fontWeight: "700", color: "#1e293b", margin: 0 },
  subtitle: { fontSize: "16px", color: "#64748b", margin: "4px 0 0 0" },
  btnPrimary: { padding: "12px 24px", background: "#3b82f6", color: "white", border: "none", borderRadius: "10px", fontWeight: "600", cursor: "pointer", boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)" },
  statsGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "16px", marginBottom: "24px" },
  statCard: { background: "white", padding: "20px", borderRadius: "16px", boxShadow: "0 4px 12px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0", display: "flex", alignItems: "center", gap: "16px" },
  statIcon: { width: "56px", height: "56px", background: "#dbeafe", borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "24px" },
  statValue: { fontSize: "28px", fontWeight: "700", color: "#1e293b" },
  statLabel: { fontSize: "14px", color: "#64748b" },
  criticalCard: { background: "#fffbeb", border: "2px solid #f59e0b", borderRadius: "16px", padding: "20px", marginBottom: "24px", boxShadow: "0 4px 12px rgba(245, 158, 11, 0.1)" },
  criticalItem: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px", background: "white", borderRadius: "12px", marginBottom: "8px", border: "1px solid #fef3c7" },
  alertBadge: { background: "#f59e0b", color: "white", padding: "4px 12px", borderRadius: "20px", fontSize: "12px", fontWeight: "700" },
  btnActionSalida: { background: "#f59e0b", color: "white", border: "none", padding: "8px 16px", borderRadius: "8px", fontWeight: "600", cursor: "pointer" },
  btnActionEntrada: { background: "#10b981", color: "white", border: "none", padding: "8px 16px", borderRadius: "8px", fontWeight: "600", cursor: "pointer" },
  twoColumnGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))", gap: "24px" },
  card: { background: "white", borderRadius: "16px", boxShadow: "0 4px 12px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0", overflow: "hidden" },
  cardHeader: { padding: "20px 24px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" },
  cardTitle: { fontSize: "18px", fontWeight: "600", color: "#1e293b" },
  listContainer: { padding: "16px" },
  listItem: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px", borderRadius: "10px", marginBottom: "8px", background: "#f8fafc" },
  listItemContent: { flex: 1 },
  listItemTitle: { fontSize: "15px", fontWeight: "600", color: "#1e293b" },
  listItemSubtitle: { fontSize: "13px", color: "#64748b" },
  quickActionsVertical: { padding: "16px", display: "flex", flexDirection: "column", gap: "12px" },
  quickActionBtn: { padding: "14px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "12px", textAlign: "left", fontWeight: "600", color: "#334155", cursor: "pointer", transition: "0.2s" },
  textWarning: { fontSize: "12px", color: "#f59e0b", fontWeight: "700", fontStyle: "italic" },
  loadingContainer: { minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" },
  spinner: { width: "40px", height: "40px", border: "4px solid #e2e8f0", borderTopColor: "#3b82f6", borderRadius: "50%", animation: "spin 0.8s linear infinite" }
};

export default DashboardRencar;